function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import flat from "flat";
import { rem } from "./utils";
// a few font sizes were cut out to make the design more consistent
// 15, 21, 24, 26, 34, 39, 55
export var baseFontSize = {
    inherit: "inherit",
    "2xs": rem(10),
    xs: rem(12),
    sm: rem(14),
    body: rem(16),
    lg: rem(18),
    xl: rem(20),
    "2xl": rem(22),
    "3xl": rem(28),
    "4xl": rem(32),
    "5xl": rem(36),
    "6xl": rem(42),
    "7xl": rem(52),
    "8xl": rem(60),
    "9xl": rem(80),
    "10xl": rem(92),
    "11xl": rem(100),
    "12xl": rem(140),
    "13xl": rem(180)
};
export var fontSizeMap = _objectSpreadProps(_objectSpread({}, baseFontSize), {
    body: {
        large: baseFontSize.xl,
        base: baseFontSize.body,
        small: baseFontSize.sm,
        xsmall: baseFontSize.xs
    },
    link: {
        large: baseFontSize.xl,
        base: baseFontSize.xs,
        small: baseFontSize["2xs"]
    },
    h1: {
        large: baseFontSize["10xl"],
        base: baseFontSize["9xl"],
        small: baseFontSize["6xl"]
    },
    h2: {
        base: baseFontSize["8xl"],
        small: baseFontSize["5xl"]
    },
    h3: {
        base: baseFontSize["4xl"],
        small: baseFontSize["3xl"]
    },
    h3s: {
        base: baseFontSize["3xl"],
        small: baseFontSize["2xl"]
    },
    h4: {
        base: baseFontSize.lg
    },
    h5: {
        base: baseFontSize.xs,
        small: baseFontSize["2xs"]
    },
    h6: {
        base: baseFontSize.lg,
        small: baseFontSize.body
    },
    caption: {
        base: baseFontSize.xs,
        small: baseFontSize["2xs"]
    }
});
export var fontSize = flat(fontSizeMap);

//# sourceMappingURL=fontSize.js.map